import { useRouter } from "next/router";
import { useMemo } from "react";

function useQuery() {
    const router = useRouter();

    return {
        router,
        query: useMemo(() => new URLSearchParams(router.query), [router.query]),
        queryParams: useMemo(() => {
            const preQuery = new URLSearchParams(router.query);
            const query = {};
            preQuery.forEach((value, key) => (query[key] = value));
            return query;
        }, [router.query]),
    };
}

export default useQuery;
